export default {"src":"/_next/static/media/estimateMatchGuarantee.d51b506a.svg","height":92,"width":87,"blurWidth":0,"blurHeight":0};